import React from 'react';
import PropTypes from 'prop-types';
import styles from './MemoryRangeV1.css';

function MemoryRangeV1({ value, onChange, label, ends }) {
    return (
        <div className={styles.root}>
            <input
                type='range'
                min='0'
                max='100'
                value={value}
                onChange={event => onChange(Number(event.target.value))}
                className={styles.range}
                style={{ '--progress': `${value}%` }}
                aria-label={label}
            />
            <div className={styles.ends}>
                {ends.map(end => <span key={end}>{end}</span>)}
            </div>
        </div>
    );
}

MemoryRangeV1.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    ends: PropTypes.arrayOf(PropTypes.string).isRequired
};

export {
    MemoryRangeV1
};
